export function isKorintUser(email: string | undefined): boolean {
  return !!email?.endsWith('@korint.io');
}
